// Application configuration from environment variables
export const appConfig = {
  name: import.meta.env.VITE_APP_NAME || 'Procimo Trackers v2',
  description: 'Real-time factory asset monitoring and analytics platform',
};

export const getAppName = (): string => {
  return appConfig.name;
};

export const getAppDescription = (): string => {
  return appConfig.description;
};
